<template>
    <v-card>
        <v-card-text>
            {{event.teamsize}}
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props:['event'],
        components: {},
        name: "TeamRegistration",
        data() {
            return {}
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped>

</style>